<template>
  <div class="addExam">
    <el-form :model="student" :rules="rules" ref="student" label-width="150px" class="demo-ruleForm">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="student.name" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <el-upload class="avatar-uploader" :action="uploadUrl" :data="datas" :show-file-list="false"
                   :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="student.avatar" :src="GLOBAL.BASE_URL+student.avatar" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="student.gender">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学号" prop="code">
        <el-input v-model="student.code" placeholder="学号"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idcard">
        <el-input v-model="student.idcard" placeholder="身份证号"></el-input>
      </el-form-item>
      <el-form-item label="准考证号" prop="exam_sequence">
        <el-input v-model="student.exam_sequence" placeholder="准考证号"></el-input>
      </el-form-item>
      <el-form-item label="班级" prop="grade_class">
        <el-input v-model="student.grade_class" placeholder="班级"></el-input>
      </el-form-item>
      <el-form-item label="班主任姓名" prop="teacher_name">
        <el-input v-model="student.teacher_name" placeholder="班主任姓名"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="mobile">
        <el-input v-model="student.mobile" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="student.email" placeholder="邮箱"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('student')" size="medium">保存</el-button>
        <el-button @click="resetForm('student')" size="medium">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
    export default {
        props: {},
        data() {
            return {
                option: [],
                datas: {
                    type: 'avatar',
                },
                student: {
                    code: '',
                    gender: 1,
                    avatar: '',
                    name: '',
                    idcard: '',
                    email: '',
                    mobile: '',
                    exam_sequence: '',
                    teacher_name: '',
                    grade_class: '',
                },
                uploadUrl: this.GLOBAL.BASE_URL + 'api/images',
                rules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur'},
                        {
                            required: true,
                            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
                            message: '姓名不支持特殊字符',
                            trigger: 'blur'
                        },

                    ],
                    idcard: [
                        {
                            required: false,
                            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                            message: '请输入正确的身份证号码',
                            trigger: 'change'
                        }
                    ],

                    email: [
                        {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}

                    ],
                    mobile: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {required: true, pattern: /^1[34578]\d{9}$/, message: '目前只支持中国大陆的手机号码', trigger: 'blur'},

                    ],
                    code: [
                        {required: true, message: '请输入学号', trigger: 'blur'}
                    ],
                    teacher_name: [
                        {required: true, message: '请输入班主任', trigger: 'blur'}
                    ],

                    examCode: [
                        {required: true, message: '请输入准考证号码', trigger: 'blur'}
                    ],
                    grad_class: [
                        {required: true, message: '请输入班级', trigger: 'blur'}
                    ],
                },
                timeList: [],
                index: '',
                imageUrl: '',
                id: 0,
                studentId: ''
            };
        },
        computed: {},
        created() {
            this.id = this.$route.query.id
            this.studentId = this.$route.query.studentId
            if (this.studentId) {
                this.studentsDetails();
            }

        },
        methods: {
            studentsDetails() {
                this.$http
                    .studentsDetails(this.studentId, {include: 'user'})
                    .then(res => {
                        this.student = res.data
                        this.student.email = res.data.user.email
                        this.student.gender = res.data.user.gender
                        this.student.avatar = res.data.user.avatar
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },

            handleAvatarSuccess(res, file) {

                this.student.avatar = res.data.path
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    this.student.exam_id=this.id
                    if (valid) {
                        //editStudent
                        if (this.studentId) {
                            this.$http
                                .editStudent(this.studentId, this.student)
                                .then(res => {
                                    if (res.code == 1) {
                                        this.$message.success("修改成功")
                                        setTimeout(() => {
                                            this.$router.go(-1)
                                        }, 1000)
                                    } else {
                                        this.$message.error(res.message)
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            this.$http
                                .addStudent(this.student)
                                .then(res => {
                                    if (res.code == 1) {
                                        this.$message.success("新增成功")
                                        setTimeout(() => {
                                            this.$router.go(-1)
                                        }, 1000)
                                    } else {
                                        this.$message.error(res.message)
                                    }


                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }


                    } else {
                        this.$message.error("请填写必填项")
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.$router.go(-1)


            }
        },
    };
</script>

<style lang="less">
  .addExam {
    .time {
      width: 174px !important;

      //   input{
      //      width:174px!important;
      //   }
    }

    .add {
      margin-bottom: 20px;
    }

    min-width: 600px;
    max-width: 1000px;

    .formItem {
      overflow: hidden;
      display: flex;

      .el-form-item {
      }
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/examManage/addStudent.vue